// extracted by mini-css-extract-plugin
export default {"section":"Section_section__4gBJb","sectionTitle":"Section_sectionTitle__aiP6L"};